import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpModule, Http, XHRBackend, RequestOptions, JsonpModule } from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import 'reflect-metadata';
import 'zone.js';

import { AppComponent } from './app.component';
import { AppBootstrapModule } from './app-bootstrap/app-bootstrap.module';

// service providers
import { providers } from '../providers';

// Module imports
import { SharedModule } from './shared/shared.module';

// Pipes providers
import { pipes } from './shared/_pipes';

import { AppRoutingModule } from './app-routing.module';
import { LoaderModule } from './components/loader/loader.module';
import { LoginModule } from './components/login/login.module';
import { ProfileManagementModule } from './components/admin/lsa-admin/profile-management/profile-management.module';
import { HotelChainManagementModule } from './components/admin/lsa-admin/hotel-chain-management/hotel-chain-management.module';
import { UserManagementModule } from './components/admin/lsa-admin/user-management/user-management.module';
import { HttpService } from './shared/_services/http.service';
import { httpFactory } from './shared/_services/http.factory';
import { LoaderService } from './shared/_services/loader.service';
import { ValidationService } from './shared/_services/validation.service';
import { HotelManagementModule } from './components/admin/hca-admin/hotels/hotel-management/hotel-management.module';
import { AuthGuard } from './shared/_guards/auth.guard';
import { UtilService } from './shared/_services/util.service';
import { SettingsModule } from './components/admin/hca-admin/settings/settings.module';
import { MarketingModule } from './components/admin/hca-admin/marketing/marketing.module';
import { CatalogComponent } from './components/modals/catalog/catalog.component';
import { ModalsModule } from './components/modals/modals.module';
import { WindowRef } from './shared/_services/windowRef';
import { MentionModule } from 'angular2-mentions/mention';
import { Router } from '@angular/router';
import { MembersManagementModule } from './components/admin/hca-admin/members/members-management/members-management.module';
import { ConciergeManagementModule } from './components/admin/hca-admin/concierge/members-management/members-management.module';
import { SmartAgentsManagementModule } from './components/admin/hca-admin/smartAgents/members-management/members-management.module';
import { ReceptionManagementModule } from './components/admin/hca-admin/reception/members-management/members-management.module';
import { EmployeesModule } from './components/admin/hca-admin/employees/employees.module';
import { BookingsModule } from './components/admin/hca-admin/bookings/bookings.module';
import { ReportsModule } from './components/admin/hca-admin/reports/reports.module';
import { HelpModule } from './components/admin/hca-admin/help/help.module';
import { PhysicalCardsModule } from './components/admin/hca-admin/physical-cards/physical-cards.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppBootstrapModule,
    HttpClientModule,
    SharedModule,
    LoaderModule,
    MentionModule,
    HttpModule,
    JsonpModule,
    ModalsModule,
    AppRoutingModule,
    LoginModule,
    ProfileManagementModule,
    HotelChainManagementModule,
    UserManagementModule,
    HotelManagementModule,
    SettingsModule,
    HelpModule,
    MarketingModule,
    BookingsModule,
    ReportsModule,
    MembersManagementModule,
    ConciergeManagementModule,
    SmartAgentsManagementModule,
    ReceptionManagementModule,
    PhysicalCardsModule,
    EmployeesModule
  ],
  providers: [
    providers,
    WindowRef,
    ValidationService,
    UtilService,
    AuthGuard,
    pipes,
    {
      provide: HttpService,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, LoaderService, Router]
    }
  ],
  exports: [
    TranslateModule
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts